import * as React from 'react'
import type { SVGIllustrationProps } from '../BaseIllustration'
import { BaseIllustration } from '../BaseIllustration'

export const LockerSpIllustration = (props: SVGIllustrationProps) => (
  <BaseIllustration xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 240 160" {...props}>
    <path
      fill="url(#dhl__illustrations_lockerspillustration_svg_a)"
      d="m48.388 157.866 24.706-4.691-32.42-17.065L16 140.817z"
    />
    <path fill="#C8C8C8" d="M115.855 2.222 40.89 16.518l32.419 17.065 74.966-14.296z" />
    <path fill="#555" d="M73.096 33.365v119.807l-32.42-17.064V16.301z" />
    <path fill="#FBCE08" d="M73.519 34.031v118.367l74.101-14.13V19.899z" />
    <path fill="#C39000" d="m73.166 93.969-.044.458 73.467-14.01v-.45z" />
    <path fill="#FCDE84" d="M73.519 94.32v.934l73.798-14.088v-.932z" />
    <path fill="#393939" d="M111.529 86.607v57.475l34.551-6.588V79.965z" />
    <path fill="#706D6D" d="m111.529 119.305 34.551 18.188-34.551 6.587z" />
    <path fill="#FCDE84" d="m111.521 113.127 3.997 2.11 25.163-4.789-14.323-7.561-14.864 2.829" />
    <path fill="url(#dhl__illustrations_lockerspillustration_svg_b)" d="m111.32 140.14 4.198-.882-4.07-2.143" />
    <path fill="#DBB569" d="m111.529 111.56 22.989-4.375-2.383-1.255-20.606 3.898z" />
    <path fill="#C39000" d="m111.489 113.105 4.024 2.125v24.024l-4.015-2.119" />
    <path fill="#FBCE08" d="M115.518 115.23v24.024l25.164-4.789v-24.023z" />
    <path fill="#fff" d="M122.885 125.153v9.039l14.692-2.802v-9.037z" />
    <path
      fill="#000"
      d="m131.362 130.817 2.575-.48v-5.391l-2.575.481zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path
      fill="#000"
      d="m124.278 132.135 2.178-.406v-5.39l-2.178.406zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path fill="#000" d="m128.868 131.282 1.072-.2v-5.385l-1.072.2zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z" />
    <path
      fill="#000"
      d="m136.193 124.524-1.093.204v5.391l1.093-.203zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path fill="#000" d="m127.636 131.515.438-.082v-5.389l-.438.081zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z" />
    <path
      fill="#FCDE84"
      d="m111.526 96.414 4.78 2.524 15.826-3.013-9.008-4.755-11.598 2.208zM16 157.86h132.06V2H16zM16 2h132.06v155.86H16z"
    />
    <path fill="#DBB569" d="m112.429 96.891 15.825-3.012-1.499-.788-15.226 2.88v.446z" />
    <path
      fill="#C39000"
      d="m111.462 96.38 4.843 2.558v15.107l-4.809-2.528zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path
      fill="#FBCE08"
      d="M116.306 98.938v15.108l15.826-3.012V95.925zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path fill="#fff" d="M120.942 105.182v5.684l9.238-1.763v-5.683zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z" />
    <path
      fill="#000"
      d="m126.27 108.744 1.619-.302v-3.391l-1.619.303zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path fill="#000" d="m121.813 109.572 1.37-.254v-3.39l-1.37.255zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z" />
    <path fill="#000" d="m124.7 109.036.675-.126v-3.387l-.675.127zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z" />
    <path fill="#000" d="m129.308 104.786-.689.129v3.391l.689-.13zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z" />
    <path
      fill="#000"
      d="M123.926 109.182c.094-.017.172-.03.276-.051v-3.39l-.276.052zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path
      fill="#C39000"
      d="m73.164 122.46-.045.459 38.194-7.313.044-.458zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path fill="#FCDE84" d="M73.37 122.85v.933l37.482-7.148v-.934zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z" />
    <path fill="#C39000" d="M110.844 41.093v.411l36.784-7.046v-.412zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z" />
    <path fill="#FCDE84" d="M110.818 41.505v.932l36.073-6.881v-.933zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z" />
    <path
      fill="#C39000"
      d="m73.165 79.504-.045.459 73.467-14.01v-.45zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path fill="#FCDE84" d="M73.31 79.91v.932l74.106-14.125v-.932zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z" />
    <path
      fill="#C39000"
      d="m73.165 65.134-.045.457 73.467-14.01v-.45zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path fill="#FCDE84" d="M73.478 65.503v.932l73.938-14.1v-.932zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z" />
    <path fill="#C39000" d="M73.12 58.325v.411l73.467-14.01v-.41zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z" />
    <path fill="#FCDE84" d="M73.525 58.643v.933l74.534-14.21v-.933zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z" />
    <path fill="#8E8E8E" d="M73.094 151.41v.44l74.965-14.295v-.44zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z" />
    <path fill="#FCDE84" d="M110.686 26.413v119.53l.843-.162V26.175zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z" />
    <path
      fill="#555"
      d="m148.059 19.785-.504.096v-.705l-1.472.308v.677l-72.99 13.92v3.516l72.99-13.918v115.084l1.472-.3V23.398l.504-.096zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path
      fill="#D30511"
      d="m78.582 48.458 3.798-.765-.206.332-3.591.723zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path
      fill="#D30511"
      d="m78.582 47.92 4.185-.843-.208.33-3.976.803zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path
      fill="#D30511"
      d="m78.583 48.995 3.413-.687-.206.33-3.206.645zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path
      fill="#D30511"
      d="m106.67 43.088-3.785.763.208-.332 3.575-.72zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path
      fill="#D30511"
      d="m106.67 43.625-4.168.84.205-.33 3.962-.798zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path
      fill="#D30511"
      d="m103.477 42.903 3.19-.643.001.29-3.397.685zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path
      fill="#D30511"
      d="m82.263 48.543 1.799-2.878 2.237-.45c.247-.05.244.047.123.24-.123.195-.33.53-.456.728-.063.101-.178.285.203.208l2.996-.604c-.249.4-1.056 1.578-2.507 1.87zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path
      fill="#D30511"
      d="m92.582 45.098-.975 1.562-2.578.52.975-1.562zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path
      fill="#D30511"
      d="m96.312 44.346-.977 1.561-2.576.521.976-1.562zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path
      fill="#D30511"
      d="m97.15 44.179-.28.448c-.323.514-.036.98 1.02.767l4.139-.833.977-1.562zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path
      fill="#D30511"
      d="m83.517 44.21-.895 1.433 4.89-.985c.248-.05.245.047.124.24-.123.194-.327.533-.452.732-.063.1-.177.283.202.206l2-.403.592-.946c.366-.587.03-1.585-1.285-1.32zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path
      fill="#D30511"
      d="m96.532 43.994-6.306 1.27 1.721-2.752 2.578-.52-.987 1.579 1.15-.232.987-1.578 2.578-.52zM16 157.861h132.059V2H16zM16 2h132.059v155.861H16z"
    />
    <path
      fill="#D30511"
      d="m101.822 40.522-1.72 2.753-2.732.55 1.722-2.754zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path
      fill="#8E8E8E"
      d="M146.587 137.394 74.566 151.13V36.597l72.021-13.734zM73.094 33.359v119.81l74.965-14.296V19.064zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z"
    />
    <path fill="#C39000" d="M111.128 30.345v113.812l.401-.077V30.26zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z" />
    <path fill="#555" d="M101.022 28.924v1.759l19.109-3.663v-1.76zM16 157.86h132.059V2H16zM16 2h132.059v155.86H16z" />
    <path fill="#FBCE08" d="m111.483 86.612-.001 1.265v56.21l34.581-6.589V79.97z" />
    <path fill="#C39000" d="M111.486 86.612v.438l34.579-6.621v-.459z" />
    <path fill="#FCDE84" d="M111.482 87.047v.932l34.579-6.622v-.93z" />
    <path
      fill="#E5E5E5"
      d="m160.528 59.468-1.612 2.216s-6.908 2.526-8.828 6.272c0 0-2.208 2.615 0 25.75l35.072.91-2.56-26.749s-.839-7.136-5.43-8.111l-8.034-1.33z"
    />
    <path fill="#C9C9C9" d="m166.666 64.454.551 6.383 1.391-.266-.552-6.449z" />
    <path fill="#DEA07B" d="M160.509 56.986V59.4l6.71 4.964 2.251-5.85z" />
    <path
      fill="#C9C9C9"
      d="m149.693 89.633 3.642-.732a16.9 16.9 0 0 1-1.06-5.052c0-1.973-.353-5.585-.353-5.585a36.6 36.6 0 0 1 1.479-8.687c1.148-2.726 7.615-6.117 7.615-6.117l-2.207-1.773a30 30 0 0 0-6.004 3.214 6.8 6.8 0 0 0-2.45 2.378 6.84 6.84 0 0 0-.993 3.273 103.4 103.4 0 0 0 .331 19.08"
    />
    <path fill="#8E8E8E" d="m160.505 59.402 6.71 4.965-1.765 2.659-6.556-5.452zM157.043 73.41l.088 14.87 1.611-.266" />
    <path
      fill="#F4F4F4"
      d="m170.838 58.739 5.981.908a6.644 6.644 0 0 1 4.415 3.612 20.85 20.85 0 0 1 1.765 8.865l-.75.31s-1.015-8.066-4.083-9.595a44 44 0 0 0-7.571-2.216z"
    />
    <path
      fill="#8E8E8E"
      d="m176.396 68.623 2.936 15.667-1.302.244M169.467 58.517l-2.251 5.85 2.516 1.352 1.104-6.98z"
    />
    <path
      fill="#F1BE96"
      d="M173.774 49.143c.441 5.451-2.538 10.061-7.262 10.327-4.723.266-8.829-4.432-9.27-9.817-.442-5.386 1.081-9.84 7.438-9.84s8.851 3.878 9.094 9.33"
    />
    <path
      fill="#28211E"
      d="M162.338 48.389c-1.17-.2-.243 3.723-.971 4.255-.728.531-1.06-2.55-2.207-2.55-1.766 0-1.391 4.433-1.965-.31-.618-5.517 1.126-9.972 7.483-9.972a8.08 8.08 0 0 1 4.776 1.02 8.12 8.12 0 0 1 3.324 3.59 2.796 2.796 0 0 1-.872 3.472c-.35.254-.754.424-1.18.494a23.1 23.1 0 0 1-8.388 0"
    />
    <path
      fill="url(#dhl__illustrations_lockerspillustration_svg_c)"
      d="m151.06 158.974 17.901-3.546-30.371-15.158-17.879 3.567z"
      opacity={0.6}
    />
    <path fill="#FDDE84" d="m168.943 107.294 53.349-9.595-30.372-15.136-53.326 9.595z" />
    <path fill="#C39000" d="M168.943 107.293v48.134l-30.349-15.136V92.157z" />
    <path fill="#FCCE09" d="M168.939 107.294v48.134l53.348-9.596V97.698z" />
    <path fill="#996A0D" d="m168.429 106.338 55.733-10.016-31.718-15.846-55.732 10.04z" />
    <path fill="#634509" d="M168.429 106.341v3.036l-31.717-15.823v-3.036z" />
    <path fill="#BC9361" d="M168.43 106.341v3.036l55.732-10.016v-3.037z" />
    <path
      fill="url(#dhl__illustrations_lockerspillustration_svg_d)"
      d="m163.93 105.431 8.917-1.773-10.529-5.296-8.917 1.772z"
      opacity={0.4}
    />
    <path fill="#FDDE84" d="m172.848 96.59 10.308-1.773-10.529-5.296-10.308 1.773z" />
    <path fill="#AA7B33" d="m168.653 94.506 10.308-1.773-2.516-1.263-10.33 1.773z" opacity={0.4} />
    <path fill="#C39000" d="M172.848 96.589v7.047l-10.529-5.296v-7.048z" />
    <path fill="#AA7B33" d="M168.653 94.507v3.28l-2.538-1.307v-3.236z" opacity={0.4} />
    <path fill="#FCCE09" d="M172.848 96.59v7.047l10.307-1.795v-7.026z" />
    <path fill="#fff" d="M174.262 98.118v4.344l7.46-1.285v-4.344z" />
    <path
      fill="#000"
      fillOpacity={0.9}
      fillRule="evenodd"
      d="m178.562 100.843 1.302-.222v-2.592l-1.302.221zM174.961 101.573l1.104-.199v-2.682l-1.104.2zM177.302 101.066h.551v-2.681h-.551zM181.011 97.832h-.552v2.593h.552zM176.684 101.177h.221V98.54h-.221z"
      clipRule="evenodd"
    />
    <path
      fill="url(#dhl__illustrations_lockerspillustration_svg_e)"
      d="m186.554 96.102 6.423-1.286-10.903-5.43-6.423 1.264z"
      opacity={0.4}
    />
    <path fill="#FDDE84" d="m192.978 77.53 19.181-3.435-10.904-5.452-19.181 3.457z" />
    <path fill="#AA7B33" d="m188.295 75.179 19.159-3.435-1.81-.909-19.203 3.435z" opacity={0.4} />
    <path fill="#C39000" d="M192.978 77.53v17.286l-10.904-5.43V72.1z" />
    <path fill="#AA7B33" d="M188.295 75.18v3.746l-1.854-.953v-3.701z" opacity={0.4} />
    <path fill="#FCCE09" d="M192.973 77.531v17.286l19.181-3.435V74.096z" />
    <path fill="#DEA07B" d="m169.91 52.42.706 2.616-1.147-.178" />
    <path
      fill="#D40511"
      d="m176.288 129.895 5.408-1.041-.287.465-5.121.975zM176.288 129.165l5.96-1.13-.287.443-5.673 1.086zM176.288 130.629l4.856-.931-.287.443-4.569.864zM216.303 122.671l-5.386 1.019.287-.443 5.099-.975zM216.304 123.382l-5.937 1.13.287-.443 5.65-1.064zM211.76 122.406l4.546-.865v.399l-4.833.909zM181.539 130.007l2.561-3.878 3.178-.598c.353 0 .353 0 .177.332l-.64.975c0 .133-.243.377.287.288l4.326-.82a5.702 5.702 0 0 1-3.576 2.527l-6.269 1.196zM196.239 125.373l-1.391 2.105-3.686.687 1.391-2.105zM201.54 124.356l-1.391 2.105-3.664.709 1.391-2.105zM202.754 124.133l-.397.599c-.464.687 0 1.329 1.457 1.041l5.893-1.13 1.39-2.105z"
    />
    <path
      fill="#D40511"
      d="m183.329 124.178-1.281 1.928 6.975-1.33c.353 0 .353 0 .177.333l-.64.975c0 .133-.243.377.287.288l2.847-.532.839-1.285c.53-.798 0-2.216-1.832-1.773zM201.874 123.891l-8.984 1.706 2.45-3.701 3.664-.709-1.412 2.128 1.655-.311 1.391-2.127 3.686-.709zM209.393 119.303l-2.516 3.612-3.819.82 2.45-3.701z"
    />
    <path fill="#C9C9C9" d="m170.528 69.686.441 4.055 2.384.421 1.766-1.196-.441-4.034z" />
    <path
      fill="#8E8E8E"
      d="m174.744 69.664-.066-.732-4.15.754.066.731M167.876 65.674a.53.53 0 0 1-.419.51.332.332 0 0 1-.419-.355.53.53 0 0 1 .419-.51.33.33 0 0 1 .419.355M168.056 67.624a.53.53 0 0 1-.419.51.33.33 0 0 1-.419-.355.53.53 0 0 1 .419-.51.332.332 0 0 1 .419.355M168.257 69.664a.53.53 0 0 1-.419.51.33.33 0 0 1-.398-.196.35.35 0 0 1-.022-.16.534.534 0 0 1 .42-.51.33.33 0 0 1 .303.067.34.34 0 0 1 .116.288"
    />
    <path fill="#fff" d="M201.233 86.062v4.876l8.387-1.44V84.6z" />
    <path
      fill="#000"
      fillOpacity={0.9}
      fillRule="evenodd"
      d="m206.068 89.119 1.478-.266V85.95l-1.478.266zM202.025 89.829l1.236-.222v-2.903l-1.236.222zM204.674 89.364h.618V86.35h-.618zM208.825 85.73h-.618v2.904h.618zM203.943 89.5h.243v-2.948h-.243z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="dhl__illustrations_lockerspillustration_svg_a"
        x1={25.319}
        x2={40.504}
        y1={150.062}
        y2={123.82}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={0.5} stopColor="gray" stopOpacity={0.5} />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_lockerspillustration_svg_b"
        x1={92.847}
        x2={116.335}
        y1={143.678}
        y2={124.331}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={0.5} stopColor="gray" stopOpacity={0.5} />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_lockerspillustration_svg_c"
        x1={122.52}
        x2={139.428}
        y1={158.974}
        y2={125.398}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_lockerspillustration_svg_d"
        x1={154.13}
        x2={160.273}
        y1={105.431}
        y2={92.424}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.245} stopOpacity={0} />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_lockerspillustration_svg_e"
        x1={1013.4}
        x2={1016.11}
        y1={256.318}
        y2={242.566}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity={0} />
        <stop offset={0.21} stopOpacity={0} />
        <stop offset={1} />
      </linearGradient>
    </defs>
  </BaseIllustration>
)
